import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';
import { CommonService } from '../services/common.service';
import * as moment from 'moment';

@Component({
  selector: 'app-fiche-contact',
  templateUrl: './fiche-contact.component.html',
  styleUrls: ['./fiche-contact.component.css']
})
export class FicheContactComponent implements OnInit {

  @Input() contact;
  @Input() client;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  searchCritere = '';
  isEmpty: Boolean = false;
  isRecherche: Boolean = false;
  listChantier = [{ id: '0', libelleObjetEntite: 'Tous' }];
  listComm = [{ id: '0', libelleObjetEntite: 'Tous' }];
  listCivilite = [{ id: 0, libelleObjetEntite: 'Aucune' }];

  @Output() hidefunction = new EventEmitter<any>();
  @Output() aftersave = new EventEmitter<any>();
  constructor(protected common: CommonService) { }

  ngOnInit() {
    this.searchChantier();
    this.searchCivilite();
    this.searchCom();

    if (!this.add) {
      this.getDetailContact(this.contact.id);
    } else {
      this.contact = {};
      this.contact['chantier'] = this.listChantier[0];
      this.contact['commercial'] = this.listComm[0];
      this.contact['civilite'] = this.listCivilite[0];
    }

    setTimeout(function () {
      $('#ficheinput2').focus();
    }, 600);
  }

  showFiche() {
    this.hidefunction.emit();
  }

  searchCivilite() {
    // this.listCivilite = [];
    // this.listCivilite.push({ id: '0', libelleObjetEntite: 'Aucune' });
    this.common.getType('typeCivilite').forEach(elt => {
      elt.libelleObjetEntite = elt.libelle;
      this.listCivilite.push(elt);
    });
  }

  filtreSearch(event) {
    this.changeInput(event.target.value);
  }

  changeRecherche() {
    if (!this.searchCritere.length) {
      this.isRecherche = false;
    }
  }

  changeInput(indexSelected) {
    const matcher = new RegExp(indexSelected, 'gi');
    if (indexSelected.length) {
      this.isRecherche = true;
    } else {
      this.isRecherche = false;
    }
    $('.info-client .items').show().not(function () {
      return matcher.test($(this).find('.champ').text());
    }).hide();
    if (!$('.group1').find('.items:visible').length) {
      $('.group1 h4').hide();
    } else {
      $('.group1 h4').show();
    }
  }


  editContact() {
    this.edit = !this.edit;
  }

  saveContact(event) {
    const contact = this.createContactObj();
    if (this.client['prospectHolding']) {
      this.client['nomclass'] = 'Client';
      const paramChantier = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 5
        },
        'HOLDING_SERVLET': 'DBGestionContact',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'true',
        'CONTACT_CLIENT': contact,
        'CLIENT': this.client,
      };
      return this.common.DBGestionAppelHolding(paramChantier).then(datas => {
        if (datas.data && datas.data !== null) {
          contact['id'] = datas.data || 0;
          this.aftersave.emit(contact);
          this.showFiche();
        }
      });
    } else {
      const param = {
        'servlet': 'DBGestionContact',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'true',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 5
          },
          'CONTACT_CLIENT': contact, // contact
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          this.aftersave.emit(datas.data);
          this.showFiche();
        }
      });
    }
  }

  createContactObj() {
    return {
      'nomclass': 'ContactClient',
      'id': this.contact['id'] || 0,
      'adresse1': this.contact['adresse1'],
      'adresse2': this.contact['adresse2'],
      'adresse3': this.contact['adresse3'],
      'chantier': {
        'id': this.contact['chantier'].id
      },
      'client': {
        'id': this.client.id,
        'prospectHolding' : this.client['prospectHolding'] || false,
        'nomclass': 'Client',
      },
      'civilite': {
        'id': this.contact['civilite'].id
      },
      'commercial': {
        'id': this.contact['commercial'].id
      },
      'fax': this.contact['fax'] || '',
      'fonction': this.contact['foction'] || '',
      'mail': this.contact['mail'] || '',
      'nom': this.contact['nom'] || '',
      'portable': this.contact['portable'] || '',
      'prenom': this.contact['prenom'] || '',
      'tel': this.contact['tel'] || '',
      'ville': this.contact['ville'] || '',
      'CP': this.contact['CP'] || '',
    };
  }

  getDetailContact(id) {
    if (this.client['prospectHolding']) {
      const nombd = this.common.local.getObject('nomBDHolding') ? this.common.local.getObject('nomBDHolding').nomBDHolding : '';
      this.client['nomclass'] = 'Client';
      const paramChantier = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 4
        },
        'HOLDING_SERVLET': 'DBGestionContact',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'true',
        'CLEF_CONTACT_CLIENT': {
          'typeParam': 'int',
          'valeur': id
        },
        'BD_HOLDING': nombd,
        'IS_PROSPECT_HOLDING': {
          'typeParam': 'boolean',
          'valeur': true
        },
      };
      return this.common.DBGestionAppelHolding(paramChantier).then(datas => {
        if (datas.data && datas.data !== null) {
          this.contact = datas.data;
          this.contact['chantier'] = this.contact['chantier'] ? this.contact['chantier'] : this.listChantier[0];
          this.contact['commercial'] = this.contact['commercial'] ? this.contact['commercial'] : this.listComm[0];
          this.contact['civilite'] = this.contact['civilite'] ? this.contact['civilite'] : this.listCivilite[0];
        }
      });
    } else {
      const param = {
        'servlet': 'DBGestionContact',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'true',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 4
          },
          'CLEF_CONTACT_CLIENT': {
            'typeParam': 'int',
            'valeur': id
          },
          'BD_HOLDING': '',
          'IS_PROSPECT_HOLDING': {
            'typeParam': 'boolean',
            'valeur': false
          }
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          this.contact = datas.data;
          this.contact['chantier'] = this.contact['chantier'] ? this.contact['chantier'] : this.listChantier[0];
          this.contact['commercial'] = this.contact['commercial'] ? this.contact['commercial'] : this.listComm[0];
          this.contact['civilite'] = this.contact['civilite'] ? this.contact['civilite'] : this.listCivilite[0];
        }
      });
    }

  }

  searchChantier() {
    if (!this.client['propectHolding']) {
      const param = {
        'servlet': 'DBGestionProspect',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 7
          },
          'CLIENT': {
            'nomclass': 'Client',
            'id': this.client['id']// id client
          },
          'CRITERE_CHANTIER': '' // recherche chantier
        }
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          const listChantier = datas.data.length ? datas.data.listChantier || [] : [];
          listChantier.forEach(elt => elt.libelleObjetEntite = elt.numChantier);
          this.listChantier.push(...listChantier);
        }
      });
    } else {
      this.client['nomclass'] = 'Client';
      const param = {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 7
        },
        'CLIENT': this.client,
        'HOLDING_SERVLET': 'DBGestionProspect',
        'HOLDING_MODULE': 'Recylog',
        'HOLDING_TYPE': 'map',
        'HOLDING_COMPRESSION': 'false',
        'CRITERE_CHANTIER': event || ''
      };
      return this.common.DBGestionAppelHolding(param).then(datas => {
        // $('#autocomplete').trigger('click');
        if (this.common.verifySession(datas)) {
          datas.data['listChantier'] = datas.data['listChantier'] || [];
          datas.data['listChantier'].forEach(elt => {
            if (elt.dateFin) {
              elt.dateFin = moment(elt.dateFin, 'YYYY-MM-DD').format('DD/MM/YYYY');
            }
            this.listChantier.push(elt);
          });
        }
      });
    }
  }

  searchCom() {
    const param = {
      'servlet': 'DBGetListUserByFonction',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': {
        'typeParam': 'int',
        'valeur': 1
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        const liste = [];
        const tab = datas.data.length ? datas.data : [];
        if (tab) {
          for (const i in tab[0]) {
            if (tab[1].length && tab[0].length) {
              liste.push({ id: parseInt(tab[1][i], 10), libelleObjetEntite: tab[0][i] });
            }
          }
        }
        this.listComm.push(...liste);
      }
    });
  }
}
